/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useCallback, useContext } from 'react';

import { StatusCode } from '../../../../../../api/enumerations';
import { getNoticeCoverage } from '../../../../../../api/theHive/noticeCoverage';
import { CoverageData } from '../../../../../../api/theHive/noticeCoverage/types';
import { GlobalContext } from '../../../../../../context/global';
import useErrorMessage from '../../../../../../hooks/useErrorMessage';

interface CoverageOperationsReturn {
  isLoading: boolean;
  coverageData: CoverageData[];
  getCoverage: () => Promise<void>;
}



export const useFetchCoverageOperations = ({
  noticeId,
}: {noticeId: number}): CoverageOperationsReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [coverageData, setCoverageData] = useState<CoverageData[]>([]);
  const { getErrorMessage } = useErrorMessage();
  const { setOpenSnackbar, setErrorMessage, setSnackbarMessage } =
    useContext(GlobalContext);

const getCoverage = useCallback(async (): Promise<void> => {
  setIsLoading(true);

    try {
      const response = await getNoticeCoverage(
        noticeId,
      );

      if (response.detail.description)
        throw new Error(response.detail.description);

      if (response.detail.status_code !== StatusCode.OK || !response.data)
        throw new Error('Algo deu errado, tente novamente');

      setCoverageData(response.data.main_regions);
    } catch (error) {
      setSnackbarMessage(getErrorMessage(error));
      setErrorMessage(true);
      setOpenSnackbar(true);
    } finally {
      setIsLoading(false);
    }
  },[noticeId]);

  return {
    isLoading,
    coverageData,
    getCoverage,
  };
};